module.exports = __webpack_public_path__ + "img/d.0617af6a.png";